<template>
  <div
    :class="{ 'rt-card-shadow': shadow }"
    class="rt-card"
    :style="computedStyle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RtCard',

  props: {
    shadow: {
      type: Boolean,
      default: true
    },
    marginBottom: {
      type: Number,
      default: undefined
    },
    overflowDisplay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedStyle () {
      let style = {};

      if (this.marginBottom !== undefined) {
        style['marginBottom'] = this.marginBottom;
      }

      if (this.overflowDisplay) {
        style['overflow'] = 'unset';
      }

      return style;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCard.vue?4b67c2ba